import {BaseDtoModel} from '../../../Services/Models/base-model.service';
import {endOfMonth, format, startOfMonth} from 'date-fns';

export class EbitdaFilters extends BaseDtoModel {
  datos_grafica!: '€' | '%';
  fecha_desde!: string;
  fecha_hasta!: string;
  filtro_local!: number;
  last_twelve_months!: boolean;
  last_year!: number;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      datos_grafica: '€',
      fecha_desde: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
      fecha_hasta: format(endOfMonth(new Date()), 'yyyy-MM-dd'),
      filtro_local: 0,
      last_year: 0,
      last_twelve_months: true,
    });
  }
}
